import React from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import PropTypes from "prop-types";

import { forceLogoutAction } from "../../redux/reducers/bouserReducer";
import { startActionWithPromise } from "../../helpers/saga-promise-helpers";
import { useWaitingStatus } from "../../hooks/useWaiter";

const propTypes = {
  row: PropTypes.object,
  modal: PropTypes.bool,
  toggle: PropTypes.func,
};

const defaultProps = {
  row: {},
  modal: false,
  toggle: () => {},
};

const UserLogout = props => {
  const dispatch = useDispatch();
  const isWaiting = useWaitingStatus(forceLogoutAction.id);

  const { modal, toggle } = props;

  const toggleModal = () => {
    if (props.toggle) props.toggle("modalLogout");
  };

  const successCallback = () => {
    if (props.refreshData) props.refreshData();
    toggle();
  };

  const failedCallback = () => {
  };

  const handleConfirm = async () => {
    try {
      await startActionWithPromise(
        forceLogoutAction,
        { id: props.row?.userId, successCallback, failedCallback },
        dispatch
      );
    } catch (error) {
      // console.log('delete error', error);
    }
  };

  return (
    <Modal
      isOpen={modal}
      toggle={toggleModal}
      centered
      size="sm"
      className="comfirmation-modal"
    >
      <ModalHeader toggle={toggleModal}>Confirmation</ModalHeader>
      <ModalBody className="m-3">
        <div>
          <p className="font-weight-bold">Following user will be logged out:</p>
          <p className="font-italic">
            "{`${props.row?.username} / ${props.row?.email}`}
          </p>
          <p className="font-weight-bold">Do you want to continue?</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" disabled={isWaiting} onClick={toggleModal}>
          No
        </Button>
        <Button
          className="ml-2"
          color="primary"
          disabled={isWaiting}
          onClick={() => handleConfirm(true)}
        >
          {isWaiting && (
            <Spinner color="secondary" size="sm" className="ml-2" />
          )}
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

UserLogout.propTypes = propTypes;
UserLogout.defaultProps = defaultProps;

export default React.memo(UserLogout);
